import { useRef } from 'react';

export const useScreenTime = () => {
    const startRef = useRef(null);

    const start = () => {
        startRef.current = Date.now();
    };

    const stop = () => {
        const start = startRef.current;
        if (!start) return null;

        const durationMs = Date.now() - start;
        if (durationMs < 1000) return null;

        const minutes = Number((durationMs / 60000).toFixed(2));
        const timestamp = new Date().toISOString();

        // reset after stop to prevent double counting
        startRef.current = null;

        return { durationMinutes: minutes, timestamp };
    };

    return { start, stop };
};






